import { CatSkeleton } from '@blocks-react/components/Skeleton';
import cx from 'classnames';
import { CatHeading } from '@blocks-react/components/Heading';
import { CustomStyledLabel } from '../../custom-styled-label/CustomStyledLabel';
import styles from '../RequestServiceSearchLoader.module.scss';
import { RequestServiceSearchLoaderDesktopProps } from '../../types';

export const RequestServiceSearchLoaderDesktop = ({
  dateLabel,
  contactLabel
}: RequestServiceSearchLoaderDesktopProps) => {
  return (
    <div data-testid="requestServiceLoaderDesktop">
      <div className="d-flex mb-4 pt-2">
        <div className={styles['equipment-info__image-loader-desktop']}>
          <CatSkeleton />
        </div>
        <div
          className={cx('ms-3', styles['equipment-info__name-loader-desktop'])}
        >
          <CatSkeleton />
        </div>
      </div>
      <CatSkeleton size="lg" />
      <div className="my-4">
        <CatSkeleton size="lg" />
        <CatSkeleton />
      </div>
      <hr className="mb-4" />
      <div className="d-flex align-items-center flex-column">
        <CatHeading variant="label">
          <CustomStyledLabel>{dateLabel}</CustomStyledLabel>
        </CatHeading>
        <div className={cx('my-4', styles['preferred-date-loader-width'])}>
          <CatSkeleton />
        </div>
        <div className={styles['preferred-date__center-loader']}>
          <CatSkeleton size="lg" />
          <CatSkeleton size="lg" />
        </div>
        <div
          className={cx(
            'mt-4 pb-2',
            styles['preferred-date__center-message-loader']
          )}
        >
          <CatSkeleton size="sm" />
        </div>
        <div
          className={cx('mb-4 pb-2', styles['preferred-date__bottom-loader'])}
        >
          <CatSkeleton size="sm" />
        </div>
      </div>
      <CatHeading variant="label" className="text-center">
        <CustomStyledLabel>{contactLabel}</CustomStyledLabel>
      </CatHeading>
      <div className="my-4">
        <CatSkeleton size="lg" />
      </div>
      <div className={styles['preferred-contact-method-loader-width']}>
        <CatSkeleton />
      </div>
      <div className="my-3 pt-2 pb-5">
        <CatSkeleton size="sm" />
        <CatSkeleton />
      </div>
    </div>
  );
};
